<svelte:head>
    <meta name="theme-color" content="#4caf50">
</svelte:head>

<script>

    import { Window, WindowItem, Button, Icon, Dialog } from 'svelte-materialify';
    import { mdiQrcode, mdiArrowRight, mdiMapMarker } from '@mdi/js';
    import Start from './pages/Start.svelte';
    import Scan from './pages/Scan.svelte';
    import Map from './pages/Map.svelte';
    import End from './pages/End.svelte';
    import User from './pages/User.svelte';
    import Send from './pages/Send.svelte';
    import Admin from './pages/Admin.svelte';
    import Verification from './pages/Verification.svelte';
    import { onMount } from 'svelte';

    const server = "square";

    let window;
    let value = 0;
    let swreg;
    let showAdmin = false;

    onMount(() => {
        if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('/service-worker.js').then(function(reg) {

				if(reg.installing) {
					console.log('Service worker installing');
				} else if(reg.waiting) {
					console.log('Service worker installed');
				} else if(reg.active) {
					console.log('Service worker active');
				}

			}).catch(function(error) {
				console.log('Registration failed with ' + error);
			});
		}

		navigator.serviceWorker.ready.then(serviceWorkerRegistration => {
			swreg = serviceWorkerRegistration;
			console.log(swreg);
		});
    })

</script>

<main class="green lighten-5">

    <div class="content">

        <Window bind:this={window} bind:value={value}>

            <WindowItem>
              <div class="slide green lighten-5 pa-3">
                
                <div>
                    <Start {window} on:openAdmin={() => showAdmin = true} />
                </div>
                
              </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <div class="container-info pa-3">

                            <div class="box white rounded elevation-1 pa-3 black-text">
    
                                <div class="icon d-flex justify-center pt-3">
    
                                    <Button fab depressed disabled class="white elevation-3">
                                        <Icon path={mdiQrcode} class="black-text" />
                                    </Button>
                                    
                                </div>
    
                                <div class="text pt-6">
    
                                    Per prima cosa bisogna scannerizzare il QR code presente sulla provetta
    
                                </div>
    
                                <div class="action pt-6">
    
                                    <Button rounded depressed class="green white-text" on:click={window.next}>
                                        Continua
                                        <Icon path={mdiArrowRight} class="ml-2" />
                                    </Button>
    
                                    <Button rounded depressed outlined class="red-text" on:click={window.previous}>
                                        Torna indietro
                                    </Button>
    
                                </div>
    
                            </div>
    
                        </div>
                    </div>
                  
                </div>
            </WindowItem>
    
            <WindowItem>
              <div class="slide green lighten-5 pa-3">
                
                <div>
                    <Scan {window} isVisible={value === 2} bind:value />
                </div>
                
              </div>
            </WindowItem>
    
            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <div class="container-info pa-3">

                            <div class="box white rounded elevation-1 pa-3 black-text">
    
                                <div class="icon d-flex justify-center pt-3">
    
                                    <Button fab depressed disabled class="white elevation-3">
                                        <Icon path={mdiMapMarker} class="black-text" />
                                    </Button>
                                    
                                </div>
    
                                <div class="text pt-6">
    
                                    Ora bisogna definire la posizione della provetta
    
                                </div>
    
                                <div class="action pt-6">
    
                                    <Button rounded depressed class="green white-text" on:click={window.next}>
                                        Continua
                                        <Icon path={mdiArrowRight} class="ml-2" />
                                    </Button>
    
                                    <Button rounded depressed outlined class="red-text" on:click={window.previous}>
                                        Torna indietro
                                    </Button>
    
                                </div>
    
                            </div>
    
                        </div>
                    </div>
                  
                </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <Map {window} bind:value />
                    </div>
                  
                </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <User _window={window} isVisible={value === 5} {swreg} />
                    </div>

                </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <Verification {server} window={window} isVisible={value === 6} {swreg} />
                    </div>
                  
                </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <End _window={window} isVisible={value === 7} bind:value />
                    </div>

                </div>
            </WindowItem>

            <WindowItem>
                <div class="slide green lighten-5 pa-3">
                  
                    <div>
                        <Send {server} _window={window} isVisible={value === 8} />
                    </div>
                  
                </div>
            </WindowItem>
    
        </Window>

    </div>

    <Dialog bind:active={showAdmin} fullscreen>
        <Admin {server} on:close={() => showAdmin = false} />
    </Dialog>

</main>

<style>

    main {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
        display: grid;
        justify-content: center;
        overflow: hidden;
	}

    main > .content {
        width: 100vw;
        max-width: 800px;
        height: 100%;
        display: grid;
        place-items: center;
        overflow: hidden;
    }

    .slide {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        overflow: hidden;
        position: relative;
        transform: translate(0);
    }

    .slide > div {
        position: fixed;
        width: 100%;
        height: 100%;
    }

    .container-info {
        position: absolute;
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
    }

    .box > div {
        width: 100%;
        display: grid;
        place-items: center;
        text-align: justify;
    }

    @media only screen and (min-width: 800px) {

        main {
            background-color: #fafafa !important;
        }

        .slide {
            height: 95vh;
            border-radius: 12px;
            overflow: hidden;
            top: 2.5vh !important;
            bottom: 2.5vh !important;
        }

    }

    :global(.s-window) {
        height: 100%;
    }

    :global(.s-window-item) {
        height: 100%;
    }

</style>